var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 4.7967C1.33203 3.1627 2.68552 1.83203 4.34839 1.83203H7.65579C9.31526 1.83203 10.6654 3.1587 10.6654 4.79003V12.2007C10.6654 13.8354 9.31187 15.1654 7.64833 15.1654H4.34228C2.68213 15.1654 1.33203 13.8387 1.33203 12.2074V11.5807V4.7967Z",
    fill: "#C6E1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5169 8.13507L12.6197 6.19573C12.4236 5.99573 12.108 5.99573 11.9126 6.19707C11.7178 6.3984 11.7185 6.72307 11.9139 6.92307L12.9534 7.98507H11.9568H6.36323C6.08728 7.98507 5.86328 8.21507 5.86328 8.4984C5.86328 8.7824 6.08728 9.01173 6.36323 9.01173H12.9534L11.9139 10.0737C11.7185 10.2737 11.7178 10.5984 11.9126 10.7997C12.0107 10.9004 12.1386 10.9511 12.2671 10.9511C12.3944 10.9511 12.5223 10.9004 12.6197 10.8011L14.5169 8.8624C14.611 8.76573 14.6643 8.63507 14.6643 8.4984C14.6643 8.3624 14.611 8.23173 14.5169 8.13507Z",
    fill: "#3694FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log_out.9d8fc51fe4168ab5ea1ac5eed77f0c28.svg";
export { ForwardRef as ReactComponent };